import React from "react"
import { Authenticator } from "@aws-amplify/ui-react"
import { Components, FormFields } from "./SignIn"

const AuthGuard = ({ updateUser, user, children }) => {
  if (user) return <>{children}</>
  return (
    <Authenticator
      components={Components}
      formFields={FormFields}
      hideSignUp


      // socialProviders={["google"]}
    >
      {({ user }) => {
        updateUser(user)
        return <>{children}</>
      }}
    </Authenticator>
  )
}

export default AuthGuard
